const cities = [
  { name: "Fort Lauderdale", zips: "33301" },
  { name: "Hollywood", zips: "33019" },
  { name: "Dania Beach", zips: "33004" },
  { name: "Wilton Manors", zips: "33305" },
  { name: "Oakland Park", zips: "33334" },
  { name: "Lauderdale-by-the-Sea", zips: "33308" },
  { name: "Pompano Beach", zips: "33060" },
  { name: "Deerfield Beach", zips: "33441" },
  { name: "Plantation", zips: "33317" },
  { name: "Sunrise", zips: "33323" },
  { name: "Davie", zips: "33314" },
  { name: "Cooper City", zips: "33328" },
  { name: "Tamarac", zips: "33321" },
  { name: "Lighthouse Point", zips: "33064" },
  { name: "Sea Ranch Lakes", zips: "33308" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or work in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function FortLauderdaleLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Fort Lauderdale & Broward County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are along the Intracoastal Waterway on Las Olas, near Port Everglades, in Wilton Manors, or anywhere in central Broward County, Fast Passport Center makes expedited passport processing simple — as a registered courier, we have guaranteed submission availability at the Miami Passport Agency.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Fort Lauderdale, the "Venice of America," is Broward County's largest city and one of South Florida's most strategically positioned travel hubs. With 165 miles of navigable waterways, a world-class cruise port at Port Everglades, and Fort Lauderdale-Hollywood International Airport (FLL) located within city limits, this is a city built on international mobility. Founded in 1911 and incorporated in 1911, Fort Lauderdale grew from a small trading post on the New River into a metropolitan area of over 180,000 residents within city limits and nearly two million across the greater Fort Lauderdale metropolitan area.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The heart of Fort Lauderdale beats along Las Olas Boulevard, the city's premier dining, shopping, and entertainment corridor that stretches from the Intracoastal Waterway to downtown. Las Olas attracts tourists from across the Americas and Europe who book cruises from nearby Port Everglades, stay at beachfront resorts, and extend their South Florida vacations with Caribbean island-hopping. This tourism ecosystem means Fort Lauderdale residents frequently host international visitors who need passport assistance — and residents themselves are constantly booking cruises, flights, and yacht charters that require current travel documents.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Port Everglades, located within Fort Lauderdale's city boundaries, is the third-busiest cruise port in the world and handles more than three million passengers annually. For Fort Lauderdale residents, a Caribbean cruise is not a special occasion — it is a regular weekend option. Royal Caribbean, Celebrity Cruises, Princess, Holland America, Carnival, Norwegian, MSC, and Disney all operate from this port, creating a constant rotation of embarkation dates that generate enormous passport demand. The proximity between downtown Fort Lauderdale neighborhoods and the cruise terminal means residents often book cruises with minimal advance planning, increasing the likelihood of last-minute passport discoveries.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Fort Lauderdale-Hollywood International Airport (FLL) is a defining travel asset. Located just minutes from downtown and most Fort Lauderdale neighborhoods, FLL serves as a major hub for Southwest, JetBlue, and Spirit Airlines with expanding international service to the Caribbean, Mexico, Central America, and South America. Unlike Miami International Airport, which requires a longer drive and more complex navigation, FLL is accessible, efficient, and increasingly competitive on international routes. Fort Lauderdale residents use this proximity to book trips with shorter lead times — a weekend in Nassau, a four-day Cozumel resort stay, a quick business meeting in Bogota.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The city's yachting and marine industry creates unique passport demand. Fort Lauderdale hosts the annual Fort Lauderdale International Boat Show, the world's largest in-water boat show, and the city is a global center for yacht brokerage, charter, and maintenance. Crew members on private yachts, marine industry professionals, and charter clients frequently need passports for international maritime travel — Bahamas day trips, Caribbean island-hopping itineraries, trans-Atlantic crossings, and Mediterranean summer seasons. These travelers often discover passport issues at the worst possible moment: the morning of a charter departure or the day before a boat show in Monaco.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Beyond tourism and marine industry travel, Fort Lauderdale maintains a diverse business community spanning healthcare (Broward Health, Memorial Healthcare System), technology, finance, real estate development, and international trade. The city's proximity to Latin America makes it a natural headquarters for companies with Caribbean and South American operations. Business travelers from Fort Lauderdale frequently book international trips with two to three weeks of notice — a client meeting in San Juan, a property inspection in Santo Domingo, a conference in Panama City. These compressed timelines make standard passport processing inadequate and create consistent demand for expedited services.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex flex-col xl:flex-row gap-6">
                <div className="flex-1">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to Fort Lauderdale — approximately 35 miles north on I-95
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Broward County</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

                {/* Map */}
                <div className="xl:w-[340px] flex-shrink-0">
                  <div className="rounded-lg overflow-hidden border border-white/10" style={{ height: '260px' }}>
                    <iframe
                      src="https://maps.google.com/maps?q=401+W+Atlantic+Ave+%23351,+Delray+Beach,+FL+33444&t=&z=15&ie=UTF8&iwloc=&output=embed"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Fast Passport Center Delray Beach Office Location"
                      aria-label="Google Map showing Fast Passport Center Delray Beach office at 401 W Atlantic Ave Suite 351"
                    />
                  </div>
                  <p className="text-white/40 text-xs mt-2 text-center">
                    401 W Atlantic Ave #351, Delray Beach, FL 33444
                  </p>
                </div>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities & Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Broward County — start online, ship overnight, and we handle the rest. As a registered courier, we have guaranteed submission availability at the Miami Passport Agency.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Hollywood", href: "/hollywood" },
                  { name: "Miami", href: "/miami" },
                  { name: "Plantation", href: "/plantation" },
                  { name: "Coral Springs", href: "/coral-springs" },
                  { name: "Weston", href: "/weston" },
                  { name: "Boca Raton", href: "/boca-raton" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}